import { H1Text } from "../../../../design";
import React from "react";
import SmallScreenHeader from "../../../../components/smallscreen/header";

const Header = (props: Props) => {
  return (
    <SmallScreenHeader>
      <H1Text>
        Account verification
      </H1Text>
    </SmallScreenHeader>
  )
};

export default Header;
